import { Box, Flex, Heading, Link, Spinner, Text, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useDocumentsViewModel } from '../../models/DocumentsViewModel';
import { TaxDocument } from '../../../types';
type TaxDocumentLinkProps = {
  document: TaxDocument;
};

const TaxDocumentLink: React.FC<TaxDocumentLinkProps> = ({ document }) => {
  const [isFetching, setIsFetching] = React.useState(false);
  const [downloadUrl, setDownloadUrl] = React.useState<string>('');
  const documentsViewModel = useDocumentsViewModel();

  const handleClick = async (e: React.MouseEvent) => {
    if (downloadUrl || isFetching) return; // Let the link's default behavior work if we have a URL

    e.preventDefault();
    setIsFetching(true);
    const url = await documentsViewModel.getTaxDocumentUrl(document);
    setIsFetching(false);
    if (url) {
      setDownloadUrl(url);
    }
  };

  return (
    <Link
      href={downloadUrl || '#'}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      textDecoration="none"
      w="full"
      color="black"
      _hover={{ textDecoration: 'none' }}>
      <Flex
        alignItems={'center'}
        justifyContent={'space-between'}
        cursor="pointer"
        borderColor="black"
        borderRadius="10px"
        borderStyle={'solid'}
        borderWidth="1px"
        padding="20px"
        shadow="0px 4px 6px -1px #00000011"
        w="full">
        <Text fontFamily={FontFamily.HELVETICA_NOW_BOLD}>{`${document.year} ${document.form.form_code}${document.form.suffix ? `-${document.form.suffix}` : ''
          }`}</Text>
        {isFetching ? (
          <Spinner boxSize={'15px'} />
        ) : (
          <Icon variant="regular" icon={downloadUrl ? "file-arrow-down" : "file"} />
        )}
      </Flex>
    </Link>
  );
};

export const TaxDocuments: React.FC = () => {
  const documentsViewModel = useDocumentsViewModel();

  const taxDocuments = documentsViewModel.taxDocuments;
  let firstColumn: TaxDocument[] = [];
  let secondColumn: TaxDocument[] = [];
  if (taxDocuments && taxDocuments.length > 0) {
    const middleItem = Math.ceil(taxDocuments.length / 2);
    firstColumn = taxDocuments.slice(0, middleItem);
    secondColumn = taxDocuments.slice(middleItem);
  } else {
    return null;
  }

  return (
    <Box w="100%" p="24px">
      <Heading lineHeight={1} fontWeight="normal" fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
        Tax Documents
      </Heading>
      <TextBlock fontSize="14px" mt="8px" mb="24px">
        Click to prepare a tax document for download. Then click again to download it.
      </TextBlock>
      <Flex flexDirection={['column', 'column', 'row']} gap="20px">
        <VStack gap="20px" w="full">
          {firstColumn?.map((document, i) => (
            <TaxDocumentLink key={`tax-doc-col-1-${i}`} document={document} />
          ))}
        </VStack>
        <VStack gap="20px" w="full">
          {secondColumn?.map((document, i) => (
            <TaxDocumentLink key={`tax-doc-col-2-${i}`} document={document} />
          ))}
        </VStack>
      </Flex>
    </Box>
  );
};
